import React from 'react';
import { Grid } from '@mui/material';

export default function Preview({ src }) {
    return (
        <Grid item container justifyContent="center" alignItems="center" className="my-m" xs={12}>
            <img src={src} alt="Imagen de prueba" width={300} height={300} />
        </Grid>
    )
}